const RecentActivityFeedback = ({ systemStatus = [], recentData = [] }) => {
  const systemStatusItems =
    systemStatus &&
    systemStatus.map((item) => ({
      title: item.location || "",
      description: item.action || "",
    }));

  // ✅ Recent activity data already array me aa raha hai
  const recentActivityItems =
    recentData &&
    recentData.map((item) => ({
      type: item.sentiment || "Positive", // ya jo bhi logic lagana ho
      title: item.location || "",
      description: item.feedback || "",
      time: new Date(item.entry_date).toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      }),
    }));

  return (
    <div className="recent-activity-container">
      {/* 🟢 Points Status */}
      <div className="recent-activity-panel system-status">
        <h2 className="panel-title">Points Status</h2>
        <div className="status-list">
          {systemStatusItems &&
            systemStatusItems.map((item, index) => (
              <div key={index} className="status-item">
                <span className="status-name">
                  {index + 1}.{" "}
                  <span style={{ color: "#000", fontWeight: "600" }}>
                    {item.title}
                  </span>
                </span>
                <div className="statusConut">
                  <span className="status-badge closed">
                    {item.description}
                  </span>
                </div>
              </div>
            ))}
        </div>
      </div>

      {/* 🕑 Recent Activity */}
      <div className="recent-activity-panel recent-activity">
        <h2 className="panel-title">Recent Feedbacks at Points</h2>
        <div className="activity-list">
          {recentActivityItems.length > 0 ? (
            recentActivityItems.map((item, index) => (
              <div key={index} className="activity-item">
                <div className={`activity-indicator ${item.type}`}></div>
                <div className="activity-content">
                  <div>
                    <div className="activity-title">{item.title}</div>
                    <div className="activity-description">
                      {item.description}
                    </div>
                  </div>
                  <div className="activity-time">{item.time}</div>
                </div>
              </div>
            ))
          ) : (
            <p>No recent activity</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default RecentActivityFeedback;
